
define("json!etc/modules.json", function(){ return {
	"Gigaset_Theme": {
		"package": "shoptheme",
		"active": true
	},

	"Gigaset_CSP": {
		"package": "gigaset_csp",
		"active": true
	},

	"Gigaset_StockNotification": {
		"package": "gigaset_stocknotification",
		"active": true
	},

	"Cartware_Checkout": {
		"package": "cartware_checkout",
		"active": true
	},

	"Gigaset_ContentBridge": {
		"package": "gigaset_contentbridge",
		"active": true
	},

	"Gigaset_Recurring": {
		"package": "gigaset_recurring",
		"active": true
	}
};});

